var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChromePicker',{staticClass:"va-advanced-color-picker",model:{value:(_vm.valueProxy),callback:function ($$v) {_vm.valueProxy=$$v},expression:"valueProxy"}})}
var staticRenderFns = []

export { render, staticRenderFns }